/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const recoveryCodesStyles = ({ colors }: StylingContextState) => ({
  stepContent: css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  `,
  successMessage: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem;
    background-color: rgba(40, 167, 69, 0.1);
    border: 1px solid rgba(40, 167, 69, 0.3);
    border-radius: 4px;
    color: ${colors.success.main};
    font-weight: 600;
    margin-bottom: 2rem;

    svg {
      color: ${colors.success.main};
      width: 20px;
      height: 20px;
    }

    p {
      margin: 0 !important;
      color: ${colors.success.main};
      font-weight: 600;
    }
  `,
  title: css`
    margin: 0 0 0.5rem 0 !important;
    font-size: 1.75rem !important;
    font-weight: 700 !important;
  `,
  warningBox: css`
    padding: 0.75rem;
    background-color: rgba(255, 193, 7, 0.1);
    border: 1px solid rgba(255, 193, 7, 0.3);
    border-radius: 4px;
    color: ${colors.text.primary};
    margin-bottom: 1rem;

    p {
      margin: 0 !important;
    }
  `,
  customButton: css`
    &:hover,
    &:active,
    &:focus {
      background-color: ${colors.primary.main} !important;
      color: ${colors.white} !important;
    }
  `,
  recoveryCodesContainer: css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    background-color: ${colors.background.secondary};
    border-radius: 8px;
    border: 1px solid ${colors.border.weak};
  `,
  recoveryCodesGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.5rem;
    margin: 0;

    @media (max-width: 550px) {
      grid-template-columns: 1fr;
    }
  `,
  recoveryCode: css`
    font-family: 'Courier New', Courier, monospace !important;
    padding: 0.75rem;
    background-color: ${colors.background.canvas};
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    text-align: center;
    margin: 0 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  `,
  actionButtons: css`
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 550px) {
      flex-direction: column;
    }
  `,
  checkboxError: css`
    color: ${colors.error.main};
    margin: 0 !important;
    min-height: 1.5rem;

    &.hidden {
      visibility: hidden;
    }
  `,
  checkboxContainer: css`
    position: relative;
    margin-bottom: 0 !important;

    > div {
      margin-bottom: 0 !important;
    }

    &.error {
      [role='checkbox'] .indicator {
        border-color: ${colors.error.main} !important;
      }
    }
  `,
  submitButton: css`
    margin-top: 1rem !important;
  `,
});
